import { render, staticRenderFns } from "./Curator_edit.vue?vue&type=template&id=91fcb6dc"
import script from "./Curator_edit.vue?vue&type=script&lang=js"
export * from "./Curator_edit.vue?vue&type=script&lang=js"
import style0 from "./Curator_edit.vue?vue&type=style&index=0&id=91fcb6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports